import { Component, OnInit, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import {  ComponentObservationPointDetails, SchematicDetails } from '../equipment-details.model';
import { DomSanitizer } from '@angular/platform-browser';
import { AppService } from '../../../../app.service';
import { ChangeCrackStatusComponent } from '../components/change-crack-status/change-crack-status.component';
import { AddCrackObsPointDialogComponent } from '../../add-crack-obs-point-dialog/add-crack-obs-point-dialog.component';
import {  ObservationPointVM } from '../../favourite-dialog/favourite-dialog-modal';
import { ImplementDetailsService } from '../../implement-details/implement-details.service';
import { SetupImplementService } from '../../setup-implement/setup-implement.service';
import { ComponentVM, ObservationPointVMEdit, SchematicDataVM } from '../../setup-implement/setup-implement.model';
import { ObspointActionHistroyComponent } from '../components/obspoint-action-histroy/obspoint-action-histroy.component';
import { CrackCommentsDialogComponent } from '../components/crack-comments-dialog/crack-comments-dialog.component';
import { NotificationsService } from 'angular2-notifications';
import { SchematicOpPopupEditAllComponent } from '../../schematic-op-popup-edit-all/schematic-op-popup-edit-all.component';
import { animate, style, transition, trigger } from '@angular/animations';
import { MatDialog } from '@angular/material/dialog';
import { SchematicCompsMarkingComponent } from '../../schematic-comps-marking-popup/schematic-comps-marking.component';
import { ConfirmationBoxComponent } from '../../../../shared/confirmation-box/confirmation-box.component';
import { ModuleType } from '../../../../shared/enums/allEnums';

@Component({
  selector: 'app-implement-asset-details',
  templateUrl: './implement-asset-details.component.html',
  styleUrls: ['./implement-asset-details.component.scss'],
  animations: [
    trigger(
      'fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 0 }),
        animate('0ms', style({ opacity: 0 }))
      ])
    ]
    )]
})
export class ImplementAssetDetailsComponent implements OnInit {

  @Input() SchematicId: number;
  @Input() cusID: number;
  @Input() SMU: number;
  @Input() isCrack: number;
  @Input() ImplementId: number;
  @Input() equipmentId: number;

  @Output() updateObs: EventEmitter<boolean> = new EventEmitter();
  @Input() displayCritical: boolean;
  @Input() displayNonCritical: boolean;
  @Input() displayGET: boolean;
  @Input() showOPType: boolean;
  @Input() showImageHx: boolean;
  @Input() showWorn: boolean;
  @Input() showCrackLength: boolean;
  @Input() showCurrentMeasure: boolean;
  @Input() showCrackSeverity: boolean;
  @Input() showStartingDim: boolean;
  @Input() showUsedLimit: boolean;
  @Input() showBudgetLife: boolean;
  @Input() showLife: boolean;
  @Input() showResidualLife100: boolean;
  @Input() showResidualLife120: boolean;
  @Input() showLifeTotalProjected: boolean;
  @Input() showInstallDate: boolean;
  @Input() showPartNo: boolean;
  @Input() showManufacturer: boolean;
  @Input() showAllCosts: boolean;
  @Input() crackSeverityList: boolean;
  @Input() activeCrackStatusIds: number[] = [];
  @Input() showLocationName: boolean;
  oldGETUri: string;
  ObservationPointDetails: ComponentObservationPointDetails[];
  FilerCrackObservationPointDetails: ComponentObservationPointDetails[];
  schematicDetails: SchematicDetails;
  schematicImage: string;
  draggableSchematicTitle: string = "Schematic";
  selectedSchematicEdit: ObservationPointVMEdit
  currentStep: number = 0;
  mouseoverOPId: number = 0;
  selectedObsPointId: number = 0;
  releaseObsPointRow: boolean = true;
  allObservationPointDetails: ComponentObservationPointDetails[] = [];
  unFilteredObsPointDetails: ComponentObservationPointDetails[] = [];

  ModuleType = ModuleType;


  constructor(private _sanitizer: DomSanitizer, private _dialog: MatDialog,
    private _appService: AppService, private _moduleService: ImplementDetailsService,
    private _implementService: SetupImplementService,
    private toastr: NotificationsService,
    private elementRef: ElementRef
  ) { }

  ngOnInit() {
    this.ObservationPointDetails = [];
    this.loadSchematicAndObservationPoints();
    //if(this.ImplementId>0 && this.ImplementId!=null){
    //    this.loadComponentList();
    //}
  }

  loadSchematicAndObservationPoints() {
    //console.log(" this.displayCritical:", this.displayCritical);
    this._moduleService.GetSchematicsImageAndObsPointsForImplement(this.ImplementId, this.SchematicId, this.displayCritical, this.displayNonCritical, this.displayGET).subscribe(details => {
      this.schematicDetails = details[0].Schematic;
      console.log("details[0]: .Schematic",details[0]);
      this.ObservationPointDetails  = details[0].ObservationPoints;
      this.allObservationPointDetails = details[0].ObservationPoints || []; 
      this.unFilteredObsPointDetails = details[0].ObservationPoints || [];
      this.applyCrackFilter();
//       this.ObservationPointDetails = [];
//       if (details[0].ObservationPoints != null && details[0].ObservationPoints.length > 0) {
//         if (this.displayCritical)
//           this.ObservationPointDetails = this.ObservationPointDetails.concat(details[0].ObservationPoints.filter(f => f.isCritical));
//         if (this.displayNonCritical)
//           this.ObservationPointDetails = this.ObservationPointDetails.concat(details[0].ObservationPoints.filter(f => !f.isCritical && !f.isGETCritical));
//         if (this.displayGET)
//           this.ObservationPointDetails = this.ObservationPointDetails.concat(details[0].ObservationPoints.filter(f => f.isGETCritical));
//         this.FilerCrackObservationPointDetails = this.ObservationPointDetails.filter(x => x.Type == 'Crack');
// //        console.log(" this.ObservationPointDetails after sort:", this.ObservationPointDetails);
//       }
    });
  }

  applyCrackFilter() {
    this.ObservationPointDetails = this.allObservationPointDetails.filter(op => {
      if (op.ObPointTypeId !== 2) {
        return true;
      }
      return this.activeCrackStatusIds.includes(op.CrackStatusId);
    });
  }

  sanitize(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/*;base64,' + image);
  }

  getCrackStatus(IsFixed: boolean) {
    if (IsFixed == true) {
      return " WornPctCell evalColorA";
    }
    else {
      return " WornPctCell evalColorX";
    }

  }

  getEvalClass(wornPct: number) {
    if (wornPct <= 30) {
      return " WornPctCell evalColorA";
    }
    else if ((wornPct > 30) && (wornPct <= 60)) {
      return " WornPctCell evalColorB";
    }
    else if ((wornPct > 60) && (wornPct <= 80)) {
      return " WornPctCell evalColorC";
    }
    else if (wornPct > 80) {
      return "WornPctCell evalColorX";
    }

    return " WornPctCell noEval";
  }

  getEvalClass2(evalCode: string) {
    if (evalCode == "A") {
      return " WornPctCell evalColorA";
    }
    else if (evalCode == "B") {
      return " WornPctCell evalColorB";
    }
    else if (evalCode == "C") {
      return " WornPctCell evalColorC";
    }
    else if (evalCode == "X") {
      return "WornPctCell evalColorX";
    }

    return " WornPctCell noEval";
  }

  getEvalClass3(evalCode: string) {
    if (evalCode == "Accepted") {
      return " WornPctCell evalColorA";
    }
    else if (evalCode == "Monitor") {
      return " WornPctCell evalColorB";
    }
    else if (evalCode == "Not Accepted") {
      return "WornPctCell evalColorX";
    }

    return " WornPctCell noEval";
  }

  getEvalClass4(evalCode: string) {
    if (evalCode == "Pass") {
      return " WornPctCell evalColorA";
    }
    else if (evalCode == "Fail") {
      return " WornPctCell evalColorX";
    }
    return " WornPctCell noEval";
  }

  getEvalClass5(evalCode: string) {
    if (evalCode == "Yes") {
      return " WornPctCell evalColorA";
    }
    else if (evalCode == "No") {
      return " WornPctCell evalColorX";
    }
    return " WornPctCell noEval";
  }

  // gotoObservationListPage() {
  //     this._appService.getApplicationConfigValue("oldGETUri").subscribe(result => {
  //         this.oldGETUri = result;
  //         if (this.cusID <= 0) {
  //             window.open(this.oldGETUri + 'GET/SelectObservationListCustomer.aspx', '');
  //         }
  //         else {
  //             window.open(this.oldGETUri + 'GET/ManageObservationLists.aspx?cu=' + this.cusID, '');
  //         }
  //     });
  // }

  gotoModifyImplementPage() {
    window.open('setup/existing-implement');
  }

  OpenCrackFixedDialog(OBPoint: ComponentObservationPointDetails) {
    //console.log("open crack statu" , OBPoint)

    if (OBPoint.Type == "Crack") {
      const inspectionPlannerDialog = this._dialog.open(ChangeCrackStatusComponent, {
        panelClass: 'removeModalOverflow',
        disableClose: true,
        data: {
          obsId: OBPoint.Id,
          compName: OBPoint.ComponentName,
          ObsName: OBPoint.Name,
          IsCrackFixed: OBPoint.IsCrackFixed,
          curretSmu: this.SMU,
          Crackcomment: OBPoint.Crackcomment,
          implementId: this.ImplementId,
          equipmentId: this.equipmentId,
        },
        minWidth: 300
      });

      inspectionPlannerDialog.afterClosed().subscribe(result => {

        if (result == true) {
          //this.updateObs.emit(true);
          this.loadSchematicAndObservationPoints();
        }
      });
    }

  }

  OpenNormalObsHistroyDialog(OBPoint: ComponentObservationPointDetails) {
    //console.log("open crack statu", OBPoint)

    if (OBPoint.ObPointTypeId !== 2) {
      //console.log("open crack statu__", OBPoint)
      let inspectionPlannerDialog = this._dialog.open(ObspointActionHistroyComponent, {
        panelClass: 'removeModalOverflow',
        disableClose: true,
        data: {
          obId: OBPoint.Id,
          CompName: OBPoint.ComponentName,
          ObsName: OBPoint.Name,
          componentId: OBPoint.ComponentId,
          isCrack: false,
        },

      });

      inspectionPlannerDialog.afterClosed().subscribe(result => {

        if (result == true) {
          //this.updateObs.emit(true);
          this.loadSchematicAndObservationPoints();
        }
      });
    }
    if (OBPoint.ObPointTypeId === 2) {
      let openRemoveImplementModalRef = this._dialog.open(ObspointActionHistroyComponent, {
        panelClass: 'removeModalOverflow',
        disableClose: true,
        data: {
          obId: OBPoint.Id,
          CompName: OBPoint.ComponentName,
          ObsName: OBPoint.Name,
          componentId: OBPoint.ComponentId,
          isCrack: true,
        }
      });
      openRemoveImplementModalRef.afterClosed().subscribe((result) => {

        if (result == true) {
          //this.updateObs.emit(true);
          this.loadSchematicAndObservationPoints();
        }
      });
    }

  }
  componentList: ComponentVM[];
  loadComponentList() {
    //this._moduleService.returnComponentsForGET(this.implementID.toString()).subscribe(res => {

    this._implementService.ReturnGETComponents(this.ImplementId).subscribe(result => {
      this.componentList = result
    }, error => { console.log(error); });
  }

  // usage example:

  obsDetails_: ObservationPointVM[];
  openSchematicWindow(SchematicImage: SchematicDetails) {
    //this.loadComponentList();
    //   console.log("this.componentList", this.componentList)
    let arr_ = [];
    let comarr = []
    let comarrfiltered = []
    this.ObservationPointDetails.map(x => {
      var neModl = new ObservationPointVM();
      neModl.ObservationPointId = x.Id;
      neModl.ObservationPointPosX = x.PositionX;
      neModl.ObservationPointPosY = x.PositionY;
      neModl.EndObservationPointPosX = x.EndPositionX;
      neModl.EndObservationPointPosY = x.EndPositionY;
      neModl.isCrackFixed = x.IsCrackFixed;
      neModl.ObservationPointName = x.Name;
      neModl.pointLedgend = 3
      arr_.push(neModl)
    })

    console.log("this.arr_", arr_)
    //TT-5468
    // this.ObservationPointDetails.map(x=>{
    //     var comModel= new ComponentsVM();
    //     comModel.ComponentId=x.ComponentId;
    //     comModel.ComponentName=x.ComponentName;
    //     comarr.push(comModel)

    // })

    // var newarr = [comarr[0]];
    // for (var i=1; i<comarr.length; i++) {
    //    if (comarr[i].ComponentId!=comarr[i-1].ComponentId) newarr.push(comarr[i]);
    // }
    this._implementService.ReturnGETComponents(this.ImplementId).subscribe(result => {
      this.componentList = result;
      const addSectionDialog = this._dialog.open(AddCrackObsPointDialogComponent, {
        width: '1300px',
        //height: '1075px',
        disableClose: true,
        data: {
          obsDetails: arr_,
          schematic: SchematicImage.Data,
          componentList: this.componentList,
          schematicId: SchematicImage.Id,
          TypeID: 1,
          disabledCrackOption: false
        }
      });
      addSectionDialog.afterClosed().subscribe(details => {
        if (details > 0) {
          //this.updateObs.emit(true);
          this.loadSchematicAndObservationPoints();
        } else {

        }
      });

    }, error => { console.log(error); });

  }

  openSchematicWindowforEdit(obserationID, imgOrSchematic) {

    if (imgOrSchematic == 1) {
      this.draggableSchematicTitle = "Implement Image";
    } else if (imgOrSchematic == 2) {
      this.draggableSchematicTitle = "Schematic";
    }
    this._implementService.GetSchematicDataForEditObsevationPoint_(obserationID, this.ImplementId).subscribe(r => {
      //console.log('r', r)


      if (r.length > 0) {
        this.selectedSchematicEdit = r[0]
        //const addSectionDialog = this._dialog.open(SchemanticOpPopupEditComponent, {
        const addSectionDialog = this._dialog.open(SchematicOpPopupEditAllComponent, {

          data: {
            schematic: this.selectedSchematicEdit,
            currentStep: 2,
            mouseoverOPId: r[0].Id,
            title: this.draggableSchematicTitle,
            obserationID: obserationID

          }
        });
        addSectionDialog.afterClosed().subscribe(details => {
          //this.updateObs.emit(true);
          this.loadSchematicAndObservationPoints();
        });

      }

    });


  }



  OpenCrackCommentDialog(OBPoint: ComponentObservationPointDetails) {

    if (OBPoint.Type == "Crack") {
      const inspectionPlannerDialog = this._dialog.open(CrackCommentsDialogComponent, {
        panelClass: 'removeModalOverflow',
        disableClose: true,
        data: {
          // obsId:OBPoint.Id,
          // compName:OBPoint.ComponentName,
          // ObsName:OBPoint.Name,
          // IsCrackFixed:OBPoint.IsCrackFixed,
          // curretSmu:this.SMU,
          Crackcomment: OBPoint.Crackcomment
        },
        // minWidth: 300
      });

      inspectionPlannerDialog.afterClosed().subscribe(result => {
        this.loadSchematicAndObservationPoints();
        // if (result==true) {
        //     this.updateObs.emit(true);
        //     //this.loadEquipmentDetails();
        // }
      });
    }

  }
  compressImage(src) {
    return new Promise((res, rej) => {
      const img = new Image();




      img.src = src;
      img.onload = () => {
        const elem = document.createElement('canvas');

        let width, height;
        width = img.width;
        height = img.height;

        console.log('width', width)
        console.log('height', height)

        var ratio = height / width; //cal aspect ratio
        let imageWidth = 800;//643
        var new_height = imageWidth * ratio; //calculate new height


        elem.width = imageWidth;
        elem.height = new_height;
        const ctx = elem.getContext('2d');
        ctx.drawImage(img, 0, 0, imageWidth, new_height);
        const data = ctx.canvas.toDataURL();
        res(data);
      }
      img.onerror = error => rej(error);
    })
  }
  onSelectPhoto(event: any, ImageID) {
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (event: any) => {

        const imageUrl = (event.target.result);
        //resize photo
        this.compressImage(imageUrl).then((res: string) => {
          // console.log("imageUrl", res)
          if (res) {
            //console.log('res', res)

            //photo.NewPhoto =  this.uploadPhoto(res.split(',')[1]);
            this.ReplacePhoto(res.split(',')[1], ImageID);
          }
        })
        //this.uploadPhoto(event.target.result.split(',')[1]);
      };
    }
  }


  ReplacePhoto(newPhoto: string, ImageID) {
    var params = new SchematicDataVM()
    params.Data = newPhoto
    params.Id = ImageID
    console.log(ImageID)
    console.log(newPhoto)

    this._implementService.ReplaceSchematic(params).subscribe(res => {
      if (res) { this.toastr.success("Updated successfully"); }
      //this.updateObs.emit(true);
      this.loadSchematicAndObservationPoints();
    })

  }

  highlightbospoint(event) {
    console.log("highlightbospoint obsPointId, this.selectedObsPointId:", event, this.selectedObsPointId);
    this.selectedObsPointId = event;
  }

  openPopup() {
    this._dialog.open(SchematicCompsMarkingComponent, {
      width: '1400px',
      // height: '900px',
      disableClose: true,
      data:{
        implementId: this.ImplementId,
        schematicId: this.schematicDetails.Id,
        schematic: this.schematicDetails.Data
      }
    });
  }

  openHideConfirmationBox(schematicId: number, schematicsName: string) {
    const dialogRef = this._dialog.open(ConfirmationBoxComponent, {
      width: '400px',
      data: {
        title: 'Hide Schematic', 
        message: `Are you sure you want to hide this schematic?\n\n${schematicsName}`,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.confirmed) {
        this._implementService.hideSchematic(this.ImplementId, schematicId, true).subscribe((r: any) => {
          let json_ = JSON.parse(r)
          if (r && r.includes("Cannot")) {
            console.log('r', r)
            this.toastr.error(r);
            //window.location.reload();
          } else if (r) {
            this.toastr.success(r);
            window.location.reload();
          } else {
            this.toastr.error("There is an error while hiding this schematic.");
          }
        })
      }
    });
  }

  //@HostListener('document:click', ['$event'])
  //public onDocumentClick(event: MouseEvent): void {
  //  const clickedInside = this.elementRef.nativeElement.contains(event.target as HTMLElement);
  //  if (!clickedInside) {
  //    this.onClickedOutside();
  //  }
  //}

  //onClickedOutside(): void {
  //  //alert('You clicked outside!');
  //  console.log("this.releaseObsPointRow outside 1:", this.releaseObsPointRow);
  //  this.releaseObsPointRow = true;
  //  this.selectedObsPointId = 0;
  //  console.log("this.releaseObsPointRow outside 2:", this.releaseObsPointRow);
  //}


}

export interface FileReaderEventTarget extends EventTarget {
  result: string;
}

export interface FileReaderEvent extends Event {
  target: FileReaderEventTarget;
  getMessage(): string;
}

